import { makeStyles } from 'tss-react/mui';

export const useProfileStyles = makeStyles({ name: 'Profile' })(theme => ({
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3)
  },
  prewrap: {
    whiteSpace: 'pre-wrap'
  },
  pendingTypography: {
    fontStyle: 'italic',
    color: theme.palette.text.secondary,
  },
  cursorNotAllowed: {
    cursor: 'not-allowed',
  },
  maxWidth400: {
    maxWidth: '400px'
  },
  maxWidth120: {
    maxWidth: '120px',
  },
  maxWidth220: {
    maxWidth: '220px',
  },
  fontSize14: {
    fontSize: '14px',
  },
  fontWeight600: {
    fontWeight: 600,
  },
  discList: {
    listStyleType: 'disc',
    paddingLeft: '1rem',
  },
  discListItem: {
    display: 'list-item',
    padding: 0,
  },
  colorSecondary: {
    color: theme.palette.text.secondary,
  },
  greySubsection: {
    padding: theme.spacing(3),
    background: theme.palette.grey[100]
  },
  fontWeight500: {
    fontWeight: 500,
  },
  optional: {
    fontWeight: 400,
    color: '#757575'
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    background: theme.palette.secondary.background,
    padding: theme.spacing(1),
    '& *': {
      color: theme.palette.secondary.main,
    }
  },
  height100: {
    height: '100%'
  },
  inPersonLabel: {
    display: 'flex',
    alignItems: 'center',
    columnGap: '1rem',
    whiteSpace: 'nowrap',
    flexWrap: 'wrap',
  },
  inPersonSupportChip: {
    background: theme.palette.info.background,
    borderColor: theme.palette.info.main,
    fontWeight: 600,
  },
  deleteButton: {
    background: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    '&:hover': {
      background: theme.palette.error.dark,
    }
  },
  textAlignCenter: {
    textAlign: 'center',
  },
  deleteModalActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    '& > button': {
      flex: 1,
    }
  }
}));
